import { useEffect, useState } from 'react';
import type { SlotToday, Dish } from '../types';
import DishCard from './DishCard';
import AteOutButton from './AteOutButton';
import { colors, mintButtonStyle, lavenderButtonStyle } from '../lib/theme';

const SLOT_LABELS: Record<string, string> = {
  BREAKFAST: 'Breakfast',
  LUNCH: 'Lunch',
  DINNER: 'Dinner',
  SNACK: 'Snack',
};

interface Props {
  data: SlotToday;
  onChoose: (dishId: number, source: 'SUGGESTED' | 'SWAPPED') => Promise<void>;
  onAteOut: () => Promise<void>;
  onUndo: (logId: number) => Promise<void>;
  onSwap: (excludeIds: number[]) => Promise<Dish[]>;
}

export default function SlotSuggestionCard({ data, onChoose, onAteOut, onUndo, onSwap }: Props) {
  const [suggestions, setSuggestions] = useState(data.suggestions);

  useEffect(() => {
    setSuggestions(data.suggestions);
  }, [data.suggestions]);

  async function handleSwap() {
    const excludeIds = suggestions.map((d) => d.id);
    const fresh = await onSwap(excludeIds);
    setSuggestions(fresh);
  }

  return (
    <section
      style={{
        background: colors.blue,
        color: colors.blueText,
        borderRadius: 14,
        padding: '1rem',
        marginBottom: '1rem',
      }}
    >
      <h3 style={{ margin: '0 0 0.75rem' }}>{SLOT_LABELS[data.slot] ?? data.slot}</h3>

      {data.logged ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {data.logged.dish ? (
            <DishCard dish={data.logged.dish} variant="flat" />
          ) : (
            <div style={{ opacity: 0.75 }}>Ate out / delivery{data.logged.note ? ` — ${data.logged.note}` : ''}</div>
          )}
          <button onClick={() => onUndo(data.logged!.id)} style={{ ...mintButtonStyle, alignSelf: 'flex-start' }}>
            Change my mind
          </button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {suggestions.length === 0 && <div style={{ opacity: 0.75 }}>No dishes set up for this slot yet.</div>}
          {suggestions.map((dish) => (
            <DishCard key={dish.id} dish={dish} variant="flat" onSelect={() => onChoose(dish.id, 'SUGGESTED')} />
          ))}
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            <button onClick={handleSwap} style={lavenderButtonStyle}>
              Show me something else
            </button>
            <AteOutButton onConfirm={onAteOut} />
          </div>
        </div>
      )}
    </section>
  );
}
